import { SaveOutlined, ReloadOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tabs, Tag } from "antd";
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';
import { ContentHeader } from '../../../components';
import { Links } from '../../../helpers/Links';
import { menuHelper } from '../../../helpers/account';
import { Link } from 'react-router-dom';
import Column from 'antd/es/table/Column';
import { getListThuLaoNguoiDaiDien } from '../../../services/thulaonguoidaidien';

const DanhSachThuLaoNDD = () => {
    const menu: any = menuHelper.checkMultiPermission([Links.ThuLaoNguoiDaiDien.ChiTiet]);
    const [danhsach, setDanhSach] = useState<Array<any>>();
    const dispatch = useDispatch();

    const timkiem = async () => {
        try {
            dispatch(showLoadingScreen());
            const data = await getListThuLaoNguoiDaiDien();
            setDanhSach(data);
        }
        catch (error: any) {
        };

        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        timkiem();
    }, []);

    return (<section>
        <ContentHeader title="Thù lao người đại diện" />
        {
            menu[Links.ThuLaoNguoiDaiDien.ChiTiet] ?
                <Row className="form-group" gutter={8}>
                    <Col span={24}>
                        {
                            <Link to={Links.ThuLaoNguoiDaiDien.ChiTiet} className="hrm-btn float-right hrm-btn-warning" ><PlusOutlined className='align-self-center' rev="" />Thêm mới</Link>
                        }
                    </Col>
                </Row> : null
        }
        <div className="card card-primary">
            <Row>
                <Col span={24}>
                    <Table
                        locale={{ emptyText: "Không có dữ liệu" }}
                        dataSource={danhsach}
                    >
                        <Column title="Năm" dataIndex="nam" key="nam" />
                        <Column title="Tên kỳ quyết" key="ten" dataIndex="ten" />
                        <Column title="Trạng thái" dataIndex="trangThai" key="trangThai"
                            render={(value: any, record: any) => {
                                switch (value) {
                                    case 0: return <Tag color="processing">Khởi tạo</Tag>;
                                    case 1: return <Tag color="success">Đã duyệt</Tag>;
                                    case 2: return <Tag color="warning">Trình duyệt</Tag>
                                }

                                return <Tag color="default">--</Tag>
                            }}
                        />
                        {
                            menu[Links.ThuLaoNguoiDaiDien.ChiTiet] &&
                            <Column
                                title=""
                                key="action"
                                render={(value, record, index) =>
                                (
                                    <Link key={"link" + index} className="hrm-btn hrm-btn-sm btn-primary" to={`${Links.ThuLaoNguoiDaiDien.ChiTiet}?id=${value?.id}`}>Xem</Link>
                                )
                                }
                            />
                        }
                    </Table>
                </Col>
            </Row>
        </div>
    </section>
    );
}

export default DanhSachThuLaoNDD;